import { useEffect, useRef, useState } from 'react';
import { View } from '@gin-betting/core';
import { useIntl, IntlShape } from 'react-intl';

import { usePrevious } from 'hooks';

interface Input {
    odd: View.Odd | null;
    isActive: boolean;
}

interface Output {
    isIncreased: boolean | null;
    intl: IntlShape;
}

const useOdd = (props: Input): Output => {
    const { odd, isActive } = props;
    const intl = useIntl();
    const timerIdRef = useRef<number | undefined>();

    const [isIncreased, setIsIncreased] = useState<boolean | null>(null);

    const { value = null, id = null } = odd || {};

    const oldOddValue = usePrevious<number | null>(value);

    useEffect(
        () => {
            const newIsIncreased =
                value && oldOddValue && value !== oldOddValue
                    ? value >= oldOddValue
                    : null;

            if (newIsIncreased !== null) {
                setIsIncreased(newIsIncreased);
                timerIdRef.current = window.setTimeout(() => {
                    setIsIncreased(null);
                }, 2200);
            }

            return () => {
                clearTimeout(timerIdRef.current);
            };
        },
        /* oldOddValue from usePrevious hook is don't need here because this ref value */
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
        [id, value]
    );

    useEffect(() => () => clearTimeout(timerIdRef.current), []);

    return {
        isIncreased: isActive ? isIncreased : null,
        intl,
    };
};

export default useOdd;
